module.exports = __webpack_public_path__ + "img/re_event2.6156fa20.png";